module.exports = __webpack_public_path__ + "img/ugm-logo.dc010808.png";